import React, { useState, useEffect } from "react";
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import axios from "../../axios";
import * as XLSX from 'xlsx';


ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
)

const Education = (props) => {

  const [education, setEducation] = useState([]);

  useEffect(() => {
    axios
      .get(`statistics/byEducation/${props?.xona}/${props?.xona2}`)
      .then((res) => {
        setEducation(res?.data);
        props?.xona4();
        // console.log('edu', res?.data)
      })
      .catch((err) => {
        console.log(err);
      });
  }, [props?.xona3]);

  let namee = [];
  let number = [];

  education?.map(el => {
    namee.push(el.education);
    number.push(el.number);
  });
  var data = {
    type: 'bar',
    labels: namee, // Edukimi
    datasets: [{
      label: 'Education ',
      data: number,  // numri
      backgroundColor: [
        'rgb(255, 99, 132)',
        'rgb(255, 159, 64)',
        'rgb(255, 205, 86)',
        'rgb(75, 192, 192)',
        'rgb(54, 162, 235)',
        'rgb(153, 102, 255)',
        'rgb(201, 203, 207)'
        //
        //transparent-colors
        // 'rgba(255, 99, 132, 0.2)',
        // 'rgba(255, 159, 64, 0.2)',
        // 'rgba(255, 205, 86, 0.2)',
        // 'rgba(75, 192, 192, 0.2)',
        // 'rgba(54, 162, 235, 0.2)',
        // 'rgba(153, 102, 255, 0.2)',
        // 'rgba(201, 203, 207, 0.2)'
      ],
      borderColor: [
        'rgb(255, 99, 132)',
        'rgb(255, 159, 64)',
        'rgb(255, 205, 86)',
        'rgb(75, 192, 192)',
        'rgb(54, 162, 235)',
        'rgb(153, 102, 255)',
        'rgb(201, 203, 207)'
      ],
      borderWidth: 2
    }]
  };


  var options = {
    maintainAspectRatio: false,
    borderRadius: 10,
    // indexAxis: 'y',
    scales: {
      y: {
        beginAtZero: true
      }
    },
    legend: {
      labels: {
        fontSize: 26
      }
    }
  }

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(education);
    XLSX.utils.sheet_add_aoa(worksheet, [['']], { origin: -1 });
    XLSX.utils.sheet_add_aoa(worksheet, [['Nga data:', props?.xona]], { origin: -1 });
    XLSX.utils.sheet_add_aoa(worksheet, [['Deri në datë :', props?.xona2]], { origin: -1 });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Education');
    XLSX.writeFile(workbook, 'education.xlsx');
};

  return (
    <>
      <div className="chart-title pt-5">
        <h3 >Education  Chart </h3>
        <button onClick={() => exportToExcel(props?.xona, props?.xona2)} className="excel-btn"><i class="fas fa-file-excel pr-2"></i>Export to Excel</button>
      </div>

      <div>
        <Bar
          data={data}
          width={300}
          height={300}
          options={options}
        />
      </div>
    </>

  )

}

export default Education;